import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import style from './index.module.scss';
import ReCAPTCHA from 'react-google-recaptcha';
import { useLang } from '@/i18n';
import FormCommon from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteForm/FormCommon';
import IconCheckbox from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteForm/FormCommon/comps/IconCheckbox';
import FormErrorTips from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteForm/FormCommon/comps/FormErrorTips';
import { message } from 'antd';
import { submitQuotation } from '../service';
import { useRouter } from 'next/router';
import { rpcMap } from '@/constants';

interface Props {
    onClose: (e: any) => void;
    open: boolean;
}

const Dialog: React.FC<Props> = ({ onClose, open }) => {
    // const { t } = useLang('powerBank.EarlyBird');
    if (!open) return null;
    const { locale = 'jp' } = useRouter();
    const recaptchaRef = useRef();

    const hl = rpcMap[locale];
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
    const [data, setData] = useState([
        {
            formType: 'checkbox',
            itemKey: 'consultationType',
            itemVal: [],
            isRequire: true,
            showError: false,
            emptyTips: 'この項目は必須です',
            label: 'ご相談のカテゴリーをお選びください',
            selectList: [
                {
                    label: 'EcoFlow商品を持っておらず、購入を検討している',
                    value: 'EcoFlow商品を持っておらず、購入を検討している',
                },
                {
                    label: 'EcoFlowの商品をすでに持っており、 他の商品を追加購入したい',
                    value: 'EcoFlowの商品をすでに持っており、 他の商品を追加購入したい',
                },
                {
                    label: 'EFの商品をすでに持っており、設置サービスの導入を討している',
                    value: 'EFの商品をすでに持っており、設置サービスの導入を討している',
                },
                {
                    label: 'その他',
                    value: 'その他',
                },
            ],
        },
        {
            formType: 'checkbox',
            itemKey: 'interestedProducts',
            itemVal: [],
            isRequire: true,
            showError: false,
            emptyTips: 'この項目は必須です',
            label: '最も興味のある商品をお選びください',
            selectList: [
                {
                    label: 'DELTA Pro',
                    value: 'DELTA Pro',
                },
                {
                    label: 'DELTA Pro 3',
                    value: 'DELTA Pro 3',
                },
                {
                    label: 'DELTA Pro Ultra',
                    value: 'DELTA Pro Ultra',
                },
                {
                    label: '分電盤＆設置サービス',
                    value: '分電盤&設置サービス',
                },
                {
                    label: 'わからない',
                    value: 'わからない',
                },
            ],
        },
        {
            formType: 'checkbox',
            itemKey: 'purpose1',
            itemVal: [],
            isRequire: true,
            formWidth: '50',
            showError: false,
            emptyTips: 'この項目は必須です',
            label: 'この製品のご利用用途をお選びください',
            selectList: [
                {
                    label: '家庭用',
                    value: '家庭用',
                },
                {
                    label: '法人用',
                    value: '法人用',
                },
            ],
        },
        {
            formType: 'checkbox',
            itemKey: 'purpose2',
            itemVal: [],
            isRequire: true,
            showError: false,
            emptyTips: 'この項目は必須です',
            label: 'ご利用目的の詳細を選択してください',
            selectList: [
                {
                    label: '防災目的',
                    value: '防災目的',
                },
                {
                    label: '電気代節約目的',
                    value: '電気代節約目的',
                },
                {
                    label: 'アウトドア目的',
                    value: 'アウトドア目的',
                },
                {
                    label: '現場作業',
                    value: '現場作業',
                },
                {
                    label: 'BCP対策（施設、法人）',
                    value: 'BCP対策（施設、法人）',
                },
                {
                    label: 'その他',
                    value: 'その他',
                },
            ],
        },
        {
            itemKey: 'consultationContent',
            itemVal: '',
            isRequire: true,
            formType: 'input',
            placeholder: '例:マンション住まいの場合、蓄電池の容量は何kWhが推奨ですか。',
            emptyTips: 'この項目は必須です',
            label: 'お問い合わせの詳細を記載してください',
        },
        {
            itemKey: 'userName',
            itemVal: '',
            isRequire: true,
            formType: 'input',
            formWidth: '50',
            emptyTips: 'この項目は必須です',
            label: 'お名前',
        },
        {
            itemKey: 'phone',
            itemVal: '',
            isRequire: false,
            formType: 'input',
            formWidth: '50',
            // emptyTips: 'この項目は必須です',
            label: '電話番号',
        },
        {
            itemKey: 'zipCode',
            itemVal: '',
            isRequire: true,
            formType: 'input',
            formWidth: '50',
            emptyTips: 'この項目は必須です',
            label: '郵便番号',
        },
        {
            itemKey: 'email',
            itemVal: '',
            isRequire: true,
            formType: 'input',
            formWidth: '50',
            emptyTips: 'この項目は必須です',
            label: 'メール', //邮件
        },
        {
            formType: 'checkbox',
            itemKey: 'contactType',
            itemVal: [],
            isRequire: true,
            formWidth: '50',
            showError: false,
            emptyTips: 'この項目は必須です',
            label: 'ご希望の連絡方法',
            selectList: [
                {
                    label: 'お電話でご連絡',
                    value: 'お電話でご連絡',
                },
                {
                    label: 'メールでご連絡',
                    value: 'メールでご連絡',
                },
                {
                    label: 'どちらでも良い',
                    value: 'どちらでも良い',
                },
            ],
        },
    ]);

    const [filledSuccessfully, setFilledSuccessfully] = useState(false);

    const changeHandle = (value: string, item, index) => {
        const vals: string[] = data[index].itemVal;
        let arr: string[] = [];
        if (item.itemKey === 'consultationType') {
            arr = [value];
        } else {
            if (vals.includes(value)) {
                vals.map((val: any) => {
                    if (val !== value) {
                        if (item.itemKey === 'consultationType') {
                        }
                        arr.push(val);
                    }
                });
            } else {
                arr = [...vals, value];
            }
        }

        // //判断是否显示错误提示
        if (item.isRequire && arr.length === 0) {
            data[index].showError = true;
        } else {
            data[index].showError = false;
        }
        data[index].itemVal = arr;
        setData(JSON.parse(JSON.stringify(data)));
    };
    const changeInputHandle = (e: any, item, index: number) => {
        const val = e.target.value;
        data[index].itemVal = val;
        if (item.isRequire && !val) {
            data[index].showError = true;
        } else {
            data[index].showError = false;
        }
        setData(JSON.parse(JSON.stringify(data)));
    };
    const submitHandle = async () => {
        if (!recaptchaResponse) return;
        const arr = data.map((item) => {
            if (item.isRequire && !item.itemVal.length) {
                item.showError = true;
            } else {
                item.showError = false;
            }
            return item;
        });
        const errorData = data.filter((item) => item.showError);
        setData(JSON.parse(JSON.stringify(arr)));
        if (errorData.length !== 0) return;
        const parameter: { [key: string]: any } = {
            recaptchaResponse,
        };
        data.map((item) => {
            if (Array.isArray(item.itemVal)) {
                item.itemVal = item.itemVal.join(',');
            }
            parameter[item.itemKey] = item.itemVal;
            return item.itemVal;
        });

        try {
            const res = await submitQuotation(parameter, 'jp');
            if (res?.code === '0') {
                setFilledSuccessfully(true);
            } else {
                message.error(res.message);
            }
        } catch (e) {
            console.error(e);
            message.error('送信失敗しました！');
        }
    };
    const onReCAPTCHAChange = async (recaptchaResponse: string) => {
        if (!recaptchaResponse) {
            return;
        }
        setRecaptchaResponse(recaptchaResponse);
    };
    return createPortal(
        <div className={style.comp}>
            <div className="mask"></div>
            {!filledSuccessfully && (
                <div className="body">
                    <div className="close" onClick={(e) => onClose(e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="black" fillOpacity="0.4" />
                            <path
                                d="M12.1262 6.46958C12.4191 6.17687 12.8939 6.17675 13.1867 6.46958C13.4794 6.76242 13.4794 7.23728 13.1867 7.53012L10.8879 9.82798L13.1867 12.1268C13.4796 12.4197 13.4796 12.8945 13.1867 13.1874C12.8938 13.4799 12.419 13.4801 12.1262 13.1874L9.82736 10.8885L7.52951 13.1874C7.23667 13.48 6.76181 13.48 6.46897 13.1874C6.17614 12.8945 6.17626 12.4197 6.46897 12.1268L8.76682 9.82798L6.46994 7.53012C6.17705 7.23723 6.17705 6.76247 6.46994 6.46958C6.76285 6.17687 7.23766 6.17675 7.53049 6.46958L9.82736 8.76743L12.1262 6.46958Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <div className="title">購入前のご相談</div>
                    <div className="form-common-item">
                        {data.map((items, i) => {
                            return (
                                <div
                                    className={`form-common-content form-common-radio form-common-checkbox ${
                                        items.showError ? ' form-common-show-error' : ''
                                    } form-common-content-${items.formWidth || 100}`}
                                >
                                    <div className="form-common-title">
                                        {items.label} {items.isRequire && <span className="Suffix">必須</span>}
                                    </div>
                                    {items.formType === 'checkbox' && (
                                        <div>
                                            <div className="form-common-radio-title">{items.placeholder}</div>
                                            <div className="form-common-radio-list">
                                                {items.formType === 'checkbox' &&
                                                    items?.selectList &&
                                                    items?.selectList.map((item: any, index: number) => {
                                                        return (
                                                            <div
                                                                className={`form-common-radio-item ${
                                                                    items.itemVal.includes(item.value) ? ' form-common-radio-item-check' : ''
                                                                }`}
                                                                key={index}
                                                                onClick={() => {
                                                                    changeHandle(item.value, items, i);
                                                                }}
                                                            >
                                                                <span className="form-common-radio-input">
                                                                    <IconCheckbox />
                                                                </span>
                                                                <span className="form-common-radio-label">{item.label}</span>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    )}
                                    {items.formType === 'input' && (
                                        <div>
                                            <input
                                                className="form-common-input"
                                                placeholder={items.placeholder}
                                                value={items.itemVal}
                                                onChange={(e) => {
                                                    changeInputHandle(e, items, i);
                                                }}
                                            />
                                        </div>
                                    )}
                                    <FormErrorTips data={items} />
                                </div>
                            );
                        })}
                    </div>
                    <div className="g-recaptcha">
                        {/* @ts-ignore */}
                        <ReCAPTCHA ref={recaptchaRef} size={'normal'} sitekey={SECRET_KEY} hl={hl} onChange={onReCAPTCHAChange} />
                    </div>
                    <div className="form-common-item-footer">
                        <p className="form-common-item-footer-tips">
                            「送信」をクリックすることで、
                            <a target="_blank" href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html">
                                プライバシーポリシー
                            </a>
                            と
                            <a target="_blank" href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html">
                                利用規約
                            </a>
                            に同意するものとみなされます。<br></br>
                            お見積りをご希望の場合、本フォーム送信後、弊社や弊社の認定工務店のスタッフよりお客様へご連絡させていただく場合がございます。
                        </p>
                        <div className={`form-common-item-footer-btn ${!recaptchaResponse ? 'disabled' : ''}`} onClick={submitHandle}>
                            送信
                        </div>
                    </div>
                </div>
            )}
            {filledSuccessfully && (
                <div className="success-body">
                    <div
                        className="close"
                        onClick={(e) => {
                            onClose(e);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="black" fillOpacity="0.4" />
                            <path
                                d="M12.1262 6.46958C12.4191 6.17687 12.8939 6.17675 13.1867 6.46958C13.4794 6.76242 13.4794 7.23728 13.1867 7.53012L10.8879 9.82798L13.1867 12.1268C13.4796 12.4197 13.4796 12.8945 13.1867 13.1874C12.8938 13.4799 12.419 13.4801 12.1262 13.1874L9.82736 10.8885L7.52951 13.1874C7.23667 13.48 6.76181 13.48 6.46897 13.1874C6.17614 12.8945 6.17626 12.4197 6.46897 12.1268L8.76682 9.82798L6.46994 7.53012C6.17705 7.23723 6.17705 6.76247 6.46994 6.46958C6.76285 6.17687 7.23766 6.17675 7.53049 6.46958L9.82736 8.76743L12.1262 6.46958Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                            <path
                                d="M25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0ZM36.6113 15.8838C36.1232 15.3958 35.3319 15.3958 34.8438 15.8838L21.1553 29.5723L14.418 22.835C13.9298 22.3468 13.1385 22.3468 12.6504 22.835L10.8818 24.6025C10.3941 25.0907 10.394 25.8821 10.8818 26.3701L20.1855 35.6729C20.6737 36.1608 21.465 36.1609 21.9531 35.6729L22.0039 35.6211C22.1735 35.5608 22.334 35.4649 22.4697 35.3291L38.3789 19.4189C38.867 18.9308 38.867 18.1395 38.3789 17.6514L36.6113 15.8838Z"
                                fill="#30BF00"
                            />
                        </svg>
                    </div>
                    <div className="text">
                        ご相談の受付が完了しました。<br></br> この度はお問い合わせいただき、ありがとうございます。<br></br>
                        内容を確認のうえ、担当より改めてご連絡させていただきます。<br></br> 今しばらくお待ちくださいますようお願い申し上げます。
                    </div>
                    <div
                        className="btn"
                        onClick={(e) => {
                            onClose(e);
                        }}
                    >
                        戻る
                    </div>
                </div>
            )}
        </div>,
        document.body,
    );
};
export default Dialog;
